<template>
    <modal :show="show" >

        <div style="margin-bottom:0px" class="card" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="modal-header" v-if="type=='Edit'">

                            <h5 class="modal-title DayHeading" id="myModalLabel"> {{ $t('AddTaxRate.UpdateTaxRate') }}</h5>

                        </div>
                        <div class="modal-header" v-else>

                            <h5 class="modal-title DayHeading" id="myModalLabel" v-if="setup==undefined"> {{ $t('AddTaxRate.AddTaxRate') }}</h5>
                            <h5 class="modal-title DayHeading" id="myModalLabel" v-else> {{ $t('AddTaxRate.SetupDefaultVAT') }}</h5>

                        </div>
                        <div >
                            <div class="card-body ">
                                <div class="row ">
                                    <div :key="render" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.code.$error}">
                                        <label class="text  font-weight-bolder"> {{ $t('AddTaxRate.Code') }}:<span class="LabelColour"> *</span></label>
                                        <input disabled class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.taxRate.code.$model" type="text" />
                                        <span v-if="$v.taxRate.code.$error" class="error">
                                            <span v-if="!$v.taxRate.code.maxLength">{{ $t('AddTaxRate.CodeLength') }}</span>
                                        </span>
                                    </div>
                                    <div v-if="english=='true'" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.name.$error}">
                                        <label class="text  font-weight-bolder"> {{ $t('AddTaxRate.TaxRateNameEn') |englishLanguage}}: <span class="LabelColour"> *</span></label>
                                        <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.taxRate.name.$model" type="text" />
                                        <span v-if="$v.taxRate.name.$error" class="error">
                                            <span v-if="!$v.taxRate.name.required">{{ $t('AddTaxRate.NameRequired') }}</span>
                                            <span v-if="!$v.taxRate.name.maxLength">{{ $t('AddTaxRate.NameLength') }}</span>
                                        </span>
                                    </div>

                                    <div v-if="isOtherLang()" class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.nameArabic.$error}">
                                        <label class="text  font-weight-bolder">{{ $t('AddTaxRate.TaxRateNameAr') |arabicLanguage}}: <span class="LabelColour"> *</span></label>
                                        <input class="form-control "  v-bind:class="isLeftToRight() ? 'text-left' : 'arabicLanguage'" v-model="$v.taxRate.nameArabic.$model" type="text" />
                                        <span v-if="$v.taxRate.nameArabic.$error" class="error">
                                            <span v-if="!$v.taxRate.nameArabic.required"> {{ $t('AddTaxRate.NameRequired') }}</span>
                                            <span v-if="!$v.taxRate.nameArabic.maxLength">{{ $t('AddTaxRate.NameLength') }}</span>
                                        </span>
                                    </div>

                                    <div class="form-group has-label col-sm-12 " v-bind:class="{'has-danger' : $v.taxRate.rate.$error}">
                                        <label class="text  font-weight-bolder"> {{ $t('AddTaxRate.TaxRate') }}: <span class="LabelColour"> *</span></label>
                                        <my-currency-input v-model="$v.taxRate.rate.$model" :isVAT="true"></my-currency-input>

                                        <!--<input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.taxRate.rate.$model"     @focus="$event.target.select()" type="number"   />-->
                                        <span v-if="$v.taxRate.rate.$error" class="error">
                                            <span v-if="!$v.taxRate.rate.required"> {{ $t('AddTaxRate.TaxRateRequired') }}</span>
                                            <span v-if="!$v.taxRate.rate.maxLength"> {{ $t('AddTaxRate.TaxRateLength') }}</span>
                                        </span>
                                    </div>
                                    <div class="form-group has-label col-sm-12 " v-if="setup!=undefined">
                                        <label class="text  font-weight-bolder">  <span>{{ $t('AddTaxRate.TaxMethod') }} :</span></label>

                                        <multiselect :options="options" v-model="taxRate.taxMethod" :show-labels="false" v-bind:placeholder="$t('AddTaxRate.SelectMethod')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                        </multiselect>
                                    </div>

                                    <div class="form-group has-label col-sm-12 " v-if="setup==undefined" v-bind:class="{'has-danger' : $v.taxRate.description.$error}">
                                        <label class="text  font-weight-bolder"> {{ $t('AddTaxRate.Description') }}: </label>
                                        <textarea class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.taxRate.description.$model" type="text" />
                                        <span v-if="$v.taxRate.description.$error" class="error">{{ $t('AddTaxRate.descriptionLength') }}</span>
                                    </div>
                                    <div class="form-group col-md-12" v-if="setup==undefined">
                                        <label style="margin: 7px;">{{ $t('AddTaxRate.Active') }}</label> <br />
                                        <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" v-bind:class="{'bootstrap-switch-on': taxRate.isActive, 'bootstrap-switch-off': !taxRate.isActive}" v-on:click="taxRate.isActive = !taxRate.isActive" style="width: 72px;">
                                            <div class="bootstrap-switch-container" style="width: 122px; margin-left: 0px;">
                                                <span class="bootstrap-switch-handle-on bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-check-2"></i>
                                                </span>
                                                <span class="bootstrap-switch-label" style="width: 30px;">&nbsp;</span>
                                                <span class="bootstrap-switch-handle-off bootstrap-switch-success" style="width: 50px;">
                                                    <i class="nc-icon nc-simple-remove"></i>
                                                </span>
                                                <input class="bootstrap-switch" type="checkbox" data-toggle="switch" checked="" data-on-label="<i class='nc-icon nc-check-2'></i>" data-off-label="<i class='nc-icon nc-simple-remove'></i>" data-on-color="success" data-off-color="success">
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-right" v-if="type=='Edit' && isValid('CanEditVatRate')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">

                            <button type="button" class="btn btn-primary  " v-on:click="SaveTaxRate" v-bind:disabled="$v.taxRate.$invalid"> {{ $t('AddTaxRate.btnUpdate') }}</button>
                            <button type="button" class="btn btn-secondary  mr-3 " v-on:click="close()">{{ $t('AddTaxRate.btnClear') }}</button>

                        </div>
                        <div class="modal-footer justify-content-right" v-if="(type!='Edit' && isValid('CanAddVatRate')) || setup"  v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">

                            <button type="button" class="btn btn-primary  " v-on:click="SaveTaxRate" v-bind:disabled="$v.taxRate.$invalid"> {{ $t('AddTaxRate.btnSave') }}</button>
                            <button type="button" class="btn btn-danger   mr-3 " v-on:click="close()">{{ $t('AddTaxRate.btnClear') }}</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </modal>
    
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'

    import 'vue-loading-overlay/dist/vue-loading.css';

    import { required, maxLength, requiredIf} from "vuelidate/lib/validators"
    import Multiselect from 'vue-multiselect'
    export default {
        components: {
            Multiselect
        },
        mixins: [clickMixin],
        props: ['show', 'taxRate', 'type' ,'setup'],
        data: function () {
            return {
                render: 0,
                options: [],
                arabic: '',
                english: '',
            }
        },
        validations: {
            taxRate: {
                name: {
                    maxLength: maxLength(50)
                },
                nameArabic: {
                    required: requiredIf((x) => {
                        if (x.name == '' || x.name == null)
                            return true;
                        return false;
                    }),
                    maxLength: maxLength(50)
                }
                , rate: {
                    required,
                    maxLength: maxLength(10)
                },
                code: {
                    maxLength: maxLength(10)
                },
                description: {
                    maxLength: maxLength(200)
                }
            }
        },
        methods: {
          
            close: function () {
                this.$emit('close');
            },
            GetAutoCodeGenerator: function () {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Product/TaxRateCode', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    
                    if (response.data != null) {
                        root.taxRate.code = response.data;
                        root.render++;
                    }
                });
            },
            SaveTaxRate: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                this.$https.post('/Product/SaveTaxRate', this.taxRate, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data.isSuccess == true) {
                        if (root.type != "Edit") {
                            root.$store.state.taxRateList.push({
                                id: response.data.taxRate.id,
                                name: response.data.taxRate.name,
                                nameArabic: response.data.taxRate.nameArabic,
                                rate: response.data.taxRate.rate,
                                description: response.data.taxRate.description,
                                code: response.data.taxRate.code,
                                isActive: response.data.taxRate.isActive,
                            })
                            root.$swal({
                                title: root.$t('AddTaxRate.Saved'),
                                text: root.$t('AddTaxRate.SavedSuccessfully'),
                                type: 'success',
                                icon:'success',
                                showConfirmButton: false,
                                timer: 1000,
                                timerProgressBar: true,

                            });
                            root.close();
                            if (root.setup) {
                                root.$emit('TaxSave', true);
                            }
                        }
                        else {
                            var data = root.$store.state.taxRateList.find(function (x) {
                                return x.id == response.data.taxRate.id;
                            });
                            data.id = response.data.taxRate.id;
                            data.name = response.data.taxRate.name;
                            data.nameArabic = response.data.taxRate.nameArabic;
                            data.rate = response.data.taxRate.rate;
                            data.description = response.data.taxRate.description;
                            data.code = response.data.taxRate.code;
                            data.isActive = response.data.taxRate.isActive;
                            root.$swal({
                                title: root.$t('AddTaxRate.Updated'),
                                text: root.$t('AddTaxRate.UpdateSuccessfully'),
                                type: 'success',
                                icon:'success',
                             
                                showConfirmButton: false,
                                timer: 800,
                                timerProgressBar: true,

                            });
                            root.close();
                        }
                    }
                    else {
                        root.$swal({
                            title: root.$t('AddTaxRate.Error'),
                            text: root.$t('AddTaxRate.NameAlreadyExist'),
                            type: 'error',
                            icon:'error',
                           
                            showConfirmButton: false,
                            timer: 800,
                            timerProgressBar: true,

                        });
                    }
                });
            }
        },
        mounted: function () {
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            if (this.taxRate.id == '00000000-0000-0000-0000-000000000000' || this.taxRate.id == undefined || this.taxRate.id == '')
                this.GetAutoCodeGenerator();
            //this.options = ['Inclusive', 'Exclusive'];
            if ((this.$i18n.locale == 'en' || this.isLeftToRight())) {
                this.options = ['Inclusive', 'Exclusive'];
            }
            else {
                this.options = ['شامل', 'غير شامل'];
            }

        }
    }
</script>
